import ZoneAliasForm  from 'scripts/defa/zones/view-zone-alias-form'
import ZoneAlertsForm from 'scripts/defa/zones/view-zone-alert-form'
import ZonePresetForm from 'scripts/defa/zones/view-zone-preset-form';
import ZoneModeForm   from 'scripts/defa/zones/view-zone-mode-form';
import ZoneMenuView   from 'scripts/defa/zones/view-zone-menu-view';
import ManualZoneForm from 'scripts/defa/zones/manual-zone-form';
import ZoneView       from 'scripts/defa/zones/view-zone-view';
import Container      from 'scripts/poppet/container';
import template       from 'templates/zonePanelContainer.jst.html';

/**
 * defa.views.ZonePanelContainer
 * A description.
 * @version 1.3.0
 */

const selectors = {
	regionZone      : '[data-region=zone]',
	regionContainer : '[data-region=container]',
};

const ZonePanelContainer = Container.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	navHandler: 'internal',
	
	regions: {
		zone      : selectors.regionZone,
		container : selectors.regionContainer,
	},
	
	modelEvents: {
		// 'sync' : 'animateChildOut',
	},
	
	childViewEvents: {
		'update:lock' : 'onLockUpdate'
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	onLockUpdate: function(){
		let zoneView = new ZoneView({
			model: this.model,
			settingsHome: this.options.settingsHome,
		});
		this.showChildView( 'zone', zoneView );
	},
	
	onChildviewClose: function(){
		this._showMenu()
	},
	
	onChildviewCancel: function(){
		this._showMenu()
	},
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	attachView: function() {
		// add the zoneView to the top first time around.
		if ( ! this.getRegion( 'zone' ).hasView() ) {
			let zoneView = new ZoneView({
				model: this.model,
				settingsHome: this.options.settingsHome,
			});
			this.showChildView( 'zone', zoneView );
		}
		
		switch( this.options.view ) {
			
			case 'menu' :
				this._showMenu();
				break;
			
			case 'mode' :
				this._showMode();
				break;
				
			case 'preset' : {
				let mode = this.model.getModel( '5' ).get( 'zoneMode' );
				if ( mode !== 'manual' && mode !== 'disabled' ) {
					this._showPreset();
				}
				break;
			}
			case 'manual':
				this._showManual();
				break;
			
			case 'alert':
				this._showAlerts();
				break;
			
			case 'alias':
				this._showAlias();
				break;
				
			default:
				console.log( 'ZonePanelContainer::attachView has no rule for ' + this.options.view );
				break;
		}
	},
	
	_showMenu: function() {
		let zoneMenuView = new ZoneMenuView({
			model: this.model,
			settingsHome: this.options.settingsHome,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		
		this.showChildView( 'container', zoneMenuView );
	},
	
	_showMode: function() {
		let zoneModeForm = new ZoneModeForm({
			model    : this.model,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		this.showChildView( 'container', zoneModeForm );
	},
	
	_showPreset: function() {
		let zonePresetForm = new ZonePresetForm({
			model: this.model,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		this.showChildView( 'container', zonePresetForm );
	},
	
	_showManual: function() {
		let manualView = new ManualZoneForm({
			model: this.model,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		this.showChildView( 'container', manualView );
	},
	
	_showAlerts: function(){
		let zoneAlertsForm = new ZoneAlertsForm({
			model: this.model,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		this.showChildView( 'container', zoneAlertsForm );
	},
	
	_showAlias: function(){
		let zoneAliasForm = new ZoneAliasForm({
			zoneNumber: this.model.get('zoneNumber'),
			model: this.options.settingsHome,
			enabled: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled,
		});
		this.showChildView( 'container', zoneAliasForm );
	}
	
	
});
	
	// attach to global space
export default ZonePanelContainer;
